import styles from "../styles/Testimonials.module.css";

const testimonials = [
  {
    name: "Michael",
    role: "Local Guest",
    text: "One of the best spots in the city. Great cocktails, amazing atmosphere and friendly staff."
  },
  {
    name: "Sophie",
    role: "Visitor",
    text: "The food was excellent and the vibe gets even better at night. Definitely coming back."
  },
  {
    name: "Andreas",
    role: "Regular Customer",
    text: "Perfect place for drinks with friends. The music, service and energy are always on point."
  }
];

function Testimonials() {
  return (
    <section className={styles.testimonials}>
      <div className={styles.container}>
        <span className={styles.subtitle}>REVIEWS</span>

        <h2>What People Say</h2>

        <p className={styles.description}>
          Real experiences from guests who visited KitchenBar.
        </p>

        <div className={styles.grid}>
          {testimonials.map((t, index) => (
            <div className={styles.card} key={index}>
              <p className={styles.text}>"{t.text}"</p>

              <div className={styles.person}>
                <div className={styles.avatar}>
                  {t.name.charAt(0)}
                </div>

                <div>
                  <h4>{t.name}</h4>
                  <span>{t.role}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Testimonials;